export default __webpack_public_path__ + "static/media/skirmishers_war_fist.c7ebdee2.jpg";